
import { Component, Vue, Prop } from "vue-property-decorator";
import { iconNode } from "utils/icons";

const escapeAttr = (value: string | number) =>
  String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;");

@Component({ name: "icon" })
export default class VIcon extends Vue {
  @Prop({ default: false }) readonly spin!: boolean;
  @Prop({ default: "md" }) readonly size!: string;
  @Prop({ default: 2 }) readonly strokeWidth!: number;

  getIcon() {
    return this.$slots.default && this.$slots.default.length
      ? (this.$slots.default[0].text || "").trim()
      : null;
  }

  getSvg() {
    const name = this.getIcon();
    const node = name ? iconNode(name) : null;
    if (!node) {
      return null;
    }
    const children = node
      .map(([tag, attrs]) => {
        const attributes = Object.keys(attrs)
          .map((key) => `${key}="${escapeAttr(attrs[key])}"`)
          .join(" ");
        return `<${tag} ${attributes}/>`;
      })
      .join("");
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${this.strokeWidth}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${children}</svg>`;
  }
}
